import React from 'react';
import { Box, Text, VStack, Heading, UnorderedList, ListItem } from '@chakra-ui/react';

const PrivacyPolicy = () => {
  return (
    <Box py={{ base: 12, md: 20 }} px={{ base: 4, md: 8 }} maxW="4xl" mx="auto">
      <VStack spacing={8} align="start">
        <VStack spacing={4} align="start">
          <Heading size="2xl" color="white">Privacy & Cookie Statement</Heading>
          <Text color="gray.400" fontSize="sm">Clover Ridge Technologies LLC — Last Updated: April 2026</Text>
        </VStack>

        <VStack spacing={6} align="start" w="full">
          <Heading size="lg" color="white">What We Collect</Heading>
          <Text color="gray.300" lineHeight="1.8">
            When you use our site or contact us, we may collect your name, email, phone number, company name, and message content. We also automatically collect basic usage data like pages visited, browser type, and IP address.
          </Text>

          <Heading size="lg" color="white">How We Use It</Heading>
          <Text color="gray.300" lineHeight="1.8">
            We use your information to respond to inquiries, deliver our consulting services, operate and improve the site, and comply with legal obligations. We do not sell your personal information.
          </Text>

          <Heading size="lg" color="white">Who We Share It With</Heading>
          <Text color="gray.300" lineHeight="1.8">
            We share data only with service providers that help us operate (such as AWS for hosting and email), when required by law, or with your consent. We do not share your information with third parties for marketing.
          </Text>

          <Heading size="lg" color="white">Cookies</Heading>
          <Text color="gray.300" lineHeight="1.8">
            We use essential cookies for site functionality and analytics cookies to understand how visitors use the site. You can control cookies through your browser settings.
          </Text>

          <Heading size="lg" color="white">Your Rights</Heading>
          <Text color="gray.300" lineHeight="1.8">
            You can request access to, correction of, or deletion of your personal information at any time by contacting us at info@cloverridgetech.com. We will respond within 30 days.
          </Text>

          <Heading size="lg" color="white">Contact</Heading>
          <Text color="gray.300" lineHeight="1.8">
            Clover Ridge Technologies LLC<br />
            Email: info@cloverridgetech.com<br />
            Phone: (770) 910-5983
          </Text>
        </VStack>
      </VStack>
    </Box>
  );
};

export default PrivacyPolicy;
